import { Component } from 'react';

import traceError from './traceError';
import ErrorContent from './ErrorContent';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // log the error to remote service
    traceError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <ErrorContent />
      );
    }

    return this.props.children;
  }
}
